import { Outlet } from 'react-router-dom'
import { EmptyState } from '@navegasistemas/dls-navega-rjs'
import { Can } from '@/components/can'
import { PageLayout } from '@/components/page-layout'

interface PermissionRouteProps {
  permission: string
}

/**
 * Rota de layout que só renderiza as rotas filhas quando o usuário tem a permissão —
 * evita que o acesso direto pela URL abra telas cujas ações a API vai negar.
 */
export function PermissionRoute({ permission }: PermissionRouteProps) {
  return (
    <Can
      permission={permission}
      fallback={
        <PageLayout>
          <EmptyState
            variant="no-access"
            title="Sem permissão para acessar esta página"
            description="Peça ao administrador da cooperativa a permissão necessária."
          />
        </PageLayout>
      }
    >
      <Outlet />
    </Can>
  )
}
